export default "__VITE_ASSET__2ea36de5__"